<script setup>
import { ref, watch } from 'vue';
import { errorsToMessage } from '../../libs/errors';

/*
- modelValue es el valor del campo que estamos monitorizando el error
- error: Es el error devuelto por el servidor

Cuando cambia el valor se limpia el error y cuando desde fuera se
asigna un error, se vuelve a mostrar
*/
const props = defineProps({
  modelValue: { type: [String, Number, Boolean], default: null },
  error: { type: [String, Array], default: null },
});

const message = ref(null);

// Cuando cambia el valor quitamos el error
watch(
  () => props.modelValue,
  () => {
    message.value = null;
  },
);

watch(
  () => props.error,
  () => {
    message.value = errorsToMessage(props.error);
  },
);
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="{ hasError: !!message }">
    <slot></slot>
    <span
      v-if="message"
      class="help-block text-danger"
      v-html="message"
    >
    </span>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../../assets/stylesheets/cifra/vars/main.scss";

  .hasError {
    :deep() {
      .form-control{
        border-color: $color-danger;
      }
      label {
        color: $color-danger;
      }
    }
  }
</style>
